<script setup>
  import Popup from "@/components/controls/Popup.vue";
  import Icon from '@/components/icons/Icon.vue';

  const emit = defineEmits(['subRegionClick']);

  const props = defineProps({
    region: {
      type: Object,
      required: true,
    }
  })
</script>
<template>
  <Popup
    v-if="region.subRegions"
    :id="props.region.name"
    class="jwx-regional-navigation__popup"
    positionY="bottom"
  >
    <template #button-content>
      <div class="jwx-popup__button" :data-icon-subtle="true" data-size="small">
        <Icon name="chevron-up-down" />
        <span class='sr-only'>Open Regional Navigation Menu</span>
      </div>
    </template>  
    <template #menu-content>
      <div class="jwx-popup-menu">
        <div class="jwx-action-menu">
          <ul class="jwx-action-menu__list">
            <li 
              v-for="subRegion in props.region.subRegions"
              :key="subRegion.name"
              class="jwx-action-menu__action"
            >
            <button
              @click.prevent="emit('subRegionClick', subRegion.c)"
              class="jwx-action-menu__action-button"
            >
              <div class="jwx-action-menu__action-label">{{ subRegion.name }}</div>
            </button>
            </li>
          </ul>
        </div>      
      </div>
    </template>
  </Popup>          
</template>